<app-flock-overview-week-registration-card
  [title]="getTitle()"
  [actions]="cardActions"
  [items]="cardItems"
>
</app-flock-overview-week-registration-card>
